import * as React from 'react';
import { GraphqlQuery } from 'requestapijs';
import {
  Loading, Table, Card, Row, Col,
  Skeleton, notify, Button,
} from 'sha-el-design';
import { Colums } from 'sha-el-design/lib/components/Table/Table';
import { FaPhone } from 'react-icons/fa';

import { Inject } from '../../helpers';
import { workListQuery } from './constant';
import { AreaNode, TownNode, AssignWorkNode } from '../../../schema';
import { nestedAccess } from 'sha-el-design/lib/helpers';
import { WorkHIstoryService } from '../../service/workHistoryService';
import { UserConsumer } from '../Common/UserContext';
import { renderCalendarFormat } from '../../helpers/date';
import { workStatusTag } from '../../helpers/status';
import { AssignWorkService } from '../../service/assignWorkService';
import { Link } from 'react-router-dom';
import '../Common/listPageStyles';
import { AllocationCard } from '../Common/AllocationCard';

export class WorkList extends React.Component<{}, State> {
  @Inject workHistoryService: WorkHIstoryService;
  @Inject assignWorkService: AssignWorkService;

  afterStack = [];

  constructor(props: Readonly<{}>) {
    super(props);

    this.state = {
      offset: 0,
      name: '',
      currentPage: 1,
      updateCount: 0,
    };
  }

  // NOTE: this component used to subscribe to userService.user$ in
  // componentDidMount, writing this.state.user -- which nothing in the
  // component ever read (identity comes from <UserConsumer> in render).
  // With no componentWillUnmount, that subscription outlived every unmount
  // and re-ran setState on a dead component on each user$ emission (BUG-08).
  // Removed rather than unsubscribed: it was pure leak.

  onNext = () => {
    let { currentPage, offset } = this.state;
    currentPage = currentPage + 1;
    offset = 20 * (currentPage - 1);
    this.setState({ currentPage, offset });
  }

  onPrev = () => {
    let { currentPage, offset } = this.state;
    if (currentPage === 1) {
      return;
    }
    else {
      currentPage = currentPage - 1;
      offset = 20 * (currentPage - 1);
      this.setState({ currentPage, offset });
    }
  }

  startCalling = (assignWork: AssignWorkNode, town?: TownNode, area?: AreaNode) => {
    const data = {
      endDateTime: null,
      calls: [],
      work: assignWork.id,
      town: nestedAccess(town, 'id'),
      area: nestedAccess(area, 'id'),
      isActive: true,
    };
    this.workHistoryService.add(
      data,
      this.handleResponse,
      () => notify({
        title: 'Something Went Wrong',
        type: 'error',
      }),
    );
  }

  handleResponse = (response) => {
    if (nestedAccess(response, 'data', 'createWorkHistory', 'errors')) {
      return notify({
        title: 'Cannot Start new work',
        message: response.data.createWorkHistory.errors[0].messages,
        type: 'error',
        duration: 5000,
      });
    }
    notify({
      title: 'Starting Work',
      type: 'info',
      duration: 2000,
      callBack: () => location.href = `active`,
    });
  }

  columns = (): Array<Colums<AssignWorkNode>> => {
    const cols: Array<Colums<AssignWorkNode>> = [{
      header: 'State',
      key: 'state',
      render: (_, obj) => obj.state.name,
    }, {
      header: 'Towns',
      key: 'towns',
      render: (_, obj) => obj.towns.map((v, i) => (
        <div className='cs-list__loc' key={i}>
          <span>
            <span className='cs-list__loc-name'>{v.name}</span>
            <span className='cs-list__count'>{v.retailerCount}</span>
          </span>
          {/* Was a bare <FaPhone onClick> -- not focusable, not keyboard
              operable, and nothing marked it as interactive. */}
          {obj.areas.length ? null : (
            <button
              type='button'
              className='cs-list__call'
              title={`Start calling ${v.name}`}
              aria-label={`Start calling ${v.name}`}
              onClick={() => this.startCalling(obj, v)}
            >
              <FaPhone size={12} />
            </button>
          )}
        </div>
      )),
    }, {
      header: 'Areas',
      key: 'areas',
      render: (_, obj) => obj.areas.map((v, i) => (
        <div className='cs-list__loc' key={i}>
          <span>
            <span className='cs-list__loc-name'>{v.name}</span>
            <span className='cs-list__count'>{v.retailerCount}</span>
          </span>
          {obj.towns.length === 1 ? (
            <button
              type='button'
              className='cs-list__call'
              title={`Start calling ${v.name}`}
              aria-label={`Start calling ${v.name}`}
              onClick={() => this.startCalling(obj, null, v)}
            >
              <FaPhone size={12} />
            </button>
          ) : null}
        </div>
      )),
    }, {
      header: 'Assignment Date',
      key: 'assignmentDate',
      render: (_, obj) => (
        <div>{renderCalendarFormat(obj.dateAssigned)}</div>
      ),
    }, {
      header: 'DeadLine',
      key: 'deadline',
      render: (_, obj) => <div>
        {renderCalendarFormat(obj.deadline)}
      </div>,
    }, {
      header: 'Status',
      key: 'status',
      render: (_, obj) => workStatusTag(obj.workStatus),
    }];

    return cols;
  }

  render() {
    const { offset, currentPage } = this.state;
    return (
      <div className='cs-list'>
        <Skeleton
          isLoading={false}
          render={() => (
            <>
              <div className='cs-list__head'>
                <div>
                  <h3 className='cs-list__title'>Work List</h3>
                  <p className='cs-list__subtitle'>
                    Allocations assigned to you. Pick a town or area to start calling.
                  </p>
                </div>
              </div>
            <Card>
              {[
                <UserConsumer key='query'>
                  {({ id, isWorkActive }) => (
                    <GraphqlQuery
                      queryString={workListQuery}
                      variables={{
                        offset,
                        caller: id,
                        isFinished: false,
                      }}
                      render={(response: { finishedFilterAssignWork: AssignWorkNode[] }, error, loading) => {
                        if (error) {
                          return <h3>Something went wrong</h3>;
                        }
                        return (
                          <Loading
                            isLoading={loading}
                            render={() => (
                              <Row justifyContent='flex-end'>
                                {isWorkActive && <Col span={4}>
                                  <Link to={'/dashboard/start_calling/active'}>
                                    <Button type='primary'>
                                      Continue Work
                                    </Button>
                                  </Link>
                                </Col>}
                                <Col>
                                  {/* Cards, not a table: the ten-column table
                                      buried progress and deadline urgency in
                                      narrow cells. Each allocation now leads
                                      with its location and carries a call
                                      button per town/area. */}
                                  {response.finishedFilterAssignWork.length ? (
                                    <div className='cs-grid'>
                                      {response.finishedFilterAssignWork.map((work) => (
                                        <AllocationCard
                                          key={work.id}
                                          work={work}
                                          locationAction={(loc) => {
                                            const isArea = !!(work.areas && work.areas.length);
                                            // Same gating as before: a town is
                                            // callable only when the allocation
                                            // has no areas; an area only when
                                            // the allocation has exactly one town.
                                            const callable = isArea
                                              ? work.towns.length === 1
                                              : true;
                                            if (!callable) { return null; }
                                            return (
                                              <button
                                                type='button'
                                                className='cs-alloc__go'
                                                title={`Start calling ${loc.name}`}
                                                aria-label={`Start calling ${loc.name}`}
                                                onClick={() => (isArea
                                                  ? this.startCalling(work, null, loc as any)
                                                  : this.startCalling(work, loc as any))}
                                              >
                                                <FaPhone size={11} /> Start
                                              </button>
                                            );
                                          }}
                                        />
                                      ))}
                                    </div>
                                  ) : (
                                    <div className='cs-list__empty'>
                                      <h4>{currentPage > 1 ? 'No more allocations' : 'No work assigned'}</h4>
                                      <p>
                                        {currentPage > 1
                                          ? 'You have reached the end of the list.'
                                          : 'When a supervisor allocates a town or area to you, it will appear here.'}
                                      </p>
                                    </div>
                                  )}
                                  <div className='cs-list__pager'>
                                    <span className='cs-list__pager-info'>
                                      {response.finishedFilterAssignWork.length
                                        ? `Showing ${offset + 1}-${offset + response.finishedFilterAssignWork.length}`
                                        : ''}
                                    </span>
                                    <button
                                      type='button'
                                      className='cs-list__page-btn'
                                      onClick={this.onPrev}
                                      disabled={currentPage === 1}
                                    >
                                      Prev
                                    </button>
                                    <span className='cs-list__page-current'>{currentPage}</span>
                                    <button
                                      type='button'
                                      className='cs-list__page-btn'
                                      onClick={this.onNext}
                                      disabled={
                                        !response.finishedFilterAssignWork.length
                                          || response.finishedFilterAssignWork.length < 20
                                      }
                                    >
                                      Next
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                            )}
                          />
                        );
                      }}
                    />
                  )}
                </UserConsumer>,
              ]}
            </Card>
            </>
          )}
        />
      </div>
    );
  }
}

interface State {
  offset: number;
  name: string;
  currentPage: number;
  updateCount: number;
}
